"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isWistiaNode = function (node) {
    return (node.tagName &&
        node.tagName === 'div' &&
        node.attrs &&
        node.attrs['data-wistia-video'] === 'true');
};
exports.default = isWistiaNode;
